import { render, staticRenderFns } from "./WorkClientProjects.vue?vue&type=template&id=db616636&scoped=true&"
import script from "./WorkClientProjects.vue?vue&type=script&lang=js&"
export * from "./WorkClientProjects.vue?vue&type=script&lang=js&"
import style0 from "./WorkClientProjects.vue?vue&type=style&index=0&id=db616636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db616636",
  null
  
)

export default component.exports